import { cn } from "@/lib/utils";

// Original Voyalyo logo asset (unmodified) shown inside a white pill so it stays
// legible on the dark theme, matching the Travel-Matching mobile app.
export const Logo = ({ className, heightClass = "h-9" }) => {
  return (
    <div
      className={cn("inline-flex items-center rounded-xl bg-white px-2 py-1 shadow-sm", className)}
      data-testid="app-logo"
    >
      <img width="256" height="256" decoding="async" src="/voyalyo-logo.perf-83bc612ef44f.webp" alt="Voyalyo" className={cn(heightClass, "w-auto object-contain")} />
    </div>
  );
};

export default Logo;
